export default __webpack_public_path__ + "static/media/test10.834c552b.png";